import { render, staticRenderFns } from "./DestroyBackupView.vue?vue&type=template&id=b7a6f46c&scoped=true&"
import script from "./DestroyBackupView.vue?vue&type=script&lang=js&"
export * from "./DestroyBackupView.vue?vue&type=script&lang=js&"
import style0 from "./DestroyBackupView.vue?vue&type=style&index=0&id=b7a6f46c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a6f46c",
  null
  
)

export default component.exports